import { DebtConsolidationIcon, HomeImprovementIcon, OtherIcon } from '../../assets/icons/CashOut';
import { NoIcon, YesIcon, FEMA } from '../../assets';
import { InvestmentIcon, PrimaryHomeIcon, SecondHomeIcon, UnderContractIcon, ThirtyDaysIcon, TwoThreeMonthsIcon, ThreePlusMonthsIcon, SingleFamilyIcon, CondoIcon, TownHomeIcon, MultiFamilyHomeIcon, ManufacturedIcon } from '../../assets/icons/Purchase';
const IconMap = {
  YesIcon: YesIcon,
  NoIcon: NoIcon,
  HomeImprovementIcon: HomeImprovementIcon,
  DebtConsolidationIcon: DebtConsolidationIcon,
  OtherIcon: OtherIcon,
  FEMA: FEMA,
  PrimaryHomeIcon: PrimaryHomeIcon,
  SecondHomeIcon: SecondHomeIcon,
  InvestmentIcon: InvestmentIcon,
  UnderContractIcon: UnderContractIcon,
  ThirtyDaysIcon: ThirtyDaysIcon,
  TwoThreeMonthsIcon: TwoThreeMonthsIcon,
  ThreePlusMonthsIcon: ThreePlusMonthsIcon,
  SingleFamilyIcon: SingleFamilyIcon,
  CondoIcon: CondoIcon,
  TownHomeIcon: TownHomeIcon,
  MultiFamilyHomeIcon: MultiFamilyHomeIcon,
  ManufacturedIcon: ManufacturedIcon
};
export default IconMap;
//# sourceMappingURL=index.js.map